'use strict';

exports.__esModule = true;
exports.widgetActions = exports.LOAD_REVIEWS = exports.GET_LAYOUT = exports.GET_PROFILE_DETAILS = undefined;

var _doctifyUtils = require('doctify-utils');

var GET_PROFILE_DETAILS = exports.GET_PROFILE_DETAILS = 'WF_GRID:GET_PROFILE_DETAILS'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var GET_LAYOUT = exports.GET_LAYOUT = 'WF_GRID:GET_LAYOUT';
var LOAD_REVIEWS = exports.LOAD_REVIEWS = 'WF_GRID:LOAD_REVIEWS';

var widgetActions = exports.widgetActions = {
    getProfileDetails: function getProfileDetails(profileId, profileType, baseUrl) {
        return {
            type: GET_PROFILE_DETAILS,
            payload: {
                profileType: profileType,
                profileId: profileId,
                baseUrl: baseUrl
            }
        };
    },
    getLayout: function getLayout(props) {
        return {
            type: GET_LAYOUT,
            payload: props

        };
    },
    loadReviews: function loadReviews(profileId, profileType, minReviewRating, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: profileType + '/' + profileId + '/reviews',
            parameters: {
                limit: 6,
                min_rating: minReviewRating
            },
            method: 'GET',
            actionType: LOAD_REVIEWS
        });
    }
};